export default {
  methods: {
    scrollIntoError(classError = ".error-message") {
      const el = document.querySelector(classError);
      if (el) {
        el.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
      }
    },
  }
};
